import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Gallery } from "@/components/landing/Gallery";
import { VibeBand } from "@/components/landing/VibeBand";
import { MenuArcade } from "@/components/landing/MenuArcade";
import { Reviews } from "@/components/landing/Reviews";
import { Owners } from "@/components/landing/Owners";
import { TherapyDogs } from "@/components/landing/TherapyDogs";
import { Visit } from "@/components/landing/Visit";
import { Footer } from "@/components/landing/Footer";
import { MusicPlayer } from "@/components/landing/MusicPlayer";
import { AuthProvider } from "@/context/AuthContext";
import AdminLogin from "@/pages/AdminLogin";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";

const LandingPage = () => (
  <div className="bg-[#1B0F2E] text-[#F5EFE6] min-h-screen selection:bg-[#FF2E88] selection:text-white">
    <Nav />
    <Hero />
    <Marquee />
    <Gallery />
    <VibeBand />
    <MenuArcade />
    <Reviews />
    <Owners />
    <TherapyDogs />
    <Visit />
    <Footer />
    <MusicPlayer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
